// if (document.querySelector('#admin')) {
//   var app = new Vue({
//     el: '#admin',
//     data: {
//       navOpen: false
//     },
//     methods: {
//       toggleNav() {
//         this.navOpen = !this.navOpen;
//       }
//     }
//   });
// }


import AdminAllocation from './allocation/AdminAllocation.vue';

if (document.querySelector('#static_fields-fields-admin')) {
  const allocationElem = document.querySelector('#static_fields-fields-admin');
  const allocationElemData = JSON.parse(allocationElem.dataset.allocations);
  var app = new Vue({
    el: '#static_fields-fields-admin',
    template: '<AdminAllocation :allocationData="allocationData"/>',
    data(){
      return {
        allocationData: allocationElemData
      }
    },
    created() {
      window.vue = this;
    },
    mounted() {
    },
    components: {AdminAllocation},
  });
  // document.querySelector('#main-form').on('submit',function(){
  //   return false;
  // });
}